export default {
  INCREASE_VALUE: 1,
  INCREASE_EXPIRATION: 2,
  INCREASE_VALUE_AND_EXPIRATION: 3,
  DECREASE_VALUE: 4,
  DECREASE_EXPIRATION: 5,
  DATA_CORRECTION: 6,
  CANCEL_ENDORSEMENT: 7
}
